import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

import type { AgenticSessionsRecentListProps } from './AgenticSessionsRecentList.tsx';

export const AgenticSessionsRecentListLoadable: LoadableType<AgenticSessionsRecentListProps> =
	LoadablePaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-AgenticSessionsRecentList" */ './AgenticSessionsRecentList.tsx'
				)
			).AgenticSessionsRecentList,
	});
